<template>
  <div>
    <v-card
      v-for="(customs, customsIndex) in tempCustoms"
      v-bind:key="'customs-' + customsIndex"
      class="mt-5"
    >
      <v-card-actions>
        <h1 class="ml-3">{{ $t("CUSTOMS") }}: {{ customs.customsName }}</h1>
        <v-spacer></v-spacer>
        <ModalAddToInvoice
          :customs="customs"
          :type="type"
          :documentType="documentType"
          :source="source"
          @addedToInvoice="addedToInvoice($event, customs.customsId)"
        ></ModalAddToInvoice>
      </v-card-actions>
      <div>
        <TableActionsForInvoice
          v-if="_.size(customs.customsActions) > 0"
          :actions="customs.customsActions"
          :header="$t('CUSTOMS')"
        ></TableActionsForInvoice>
      </div>
    </v-card>
  </div>
</template>
<script>
import ModalAddToInvoice from "@/modules/stock/components/actions/stockList/ModalAddToInvoice.vue";
import TableActionsForInvoice from "@/modules/stock/components/actions/stockList/TableActionsForInvoice.vue";
import _ from "lodash";
export default {
  name: "WrapperCustomsForInvoice",
  inheritAttrs: false,
  props: {
    customs: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: function() {
        return "incoming";
      }
    },
    documentType: {
      type: String,
      default: function() {
        return "customs";
      }
    }
  },
  data() {
    return {
      source: "customs",
      search: "",
      docTotalWithVatCurrency: ""
    };
  },
  components: {
    ModalAddToInvoice,
    TableActionsForInvoice
  },
  computed: {
    tempCustoms: {
      get: function() {
        return this.customs;
      },
      set: function(newValue) {
        this.$emit("update:customs", newValue);
      }
    }
  },
  methods: {
    addedToInvoice(params, customsId) {
      let args = {
        ...params,
        customsId: customsId
      };
      this.$emit("addedToInvoice", args);
    }
  }
};
</script>
